import * as tslib_1 from "tslib";
import { observable, action } from 'mobx';
import TaskApi from '../services/TaskApi';
import { areDateEquals, toLocaleDate } from '../utils/dates';
var TimeItemCollection = /** @class */ (function () {
    function TimeItemCollection(items) {
        this.items = items;
    }
    TimeItemCollection.prototype.get = function (id) {
        return this.items.find(function (i) { return i.id === id; });
    };
    TimeItemCollection.prototype.getAllByDay = function (day) {
        var date = toLocaleDate(day);
        return this.items.filter(function (i) { return areDateEquals(i.date, date); });
    };
    TimeItemCollection.prototype.timeSpent = function () {
        return this.items.reduce(function (sum, time) { return sum + Number(time.duration); }, 0);
    };
    TimeItemCollection.prototype.timeSpentOn = function (day) {
        var date = toLocaleDate(day);
        var duration = this.items
            .filter(function (i) { return areDateEquals(i.date, date); })
            .reduce(function (sum, i) { return sum + Number(i.duration); }, 0);
        return duration;
    };
    TimeItemCollection.prototype.notesOn = function (day) {
        var date = toLocaleDate(day);
        var notes = this.items
            .filter(function (i) { return areDateEquals(i.date, date); })
            .reduce(function (sum, i) { return sum + (i.note || ''); }, '');
        return notes;
    };
    TimeItemCollection.prototype.add = function (payload) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var item;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload.date = toLocaleDate(payload.date);
                        return [4 /*yield*/, TaskApi.addItem(payload)];
                    case 1:
                        item = _a.sent();
                        this.items = this.items.concat([item]);
                        return [2 /*return*/];
                }
            });
        });
    };
    TimeItemCollection.prototype.remove = function (id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var item;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        item = this.get(id);
                        if (!item) return [3 /*break*/, 2];
                        return [4 /*yield*/, TaskApi.deleteItem(item)];
                    case 1:
                        _a.sent();
                        this.items = this.items.filter(function (i) { return i.id !== id; });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TimeItemCollection.prototype.removeAllOn = function (day) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var items, ids, promises;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        items = this.getAllByDay(day);
                        ids = items.map(function (i) { return i.id; });
                        promises = items.map(function (i) { return TaskApi.deleteItem(i); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a.sent();
                        this.items = this.items.filter(function (i) { return ids.indexOf(i.id) < 0; });
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        observable
    ], TimeItemCollection.prototype, "items", void 0);
    tslib_1.__decorate([
        action.bound
    ], TimeItemCollection.prototype, "add", null);
    tslib_1.__decorate([
        action.bound
    ], TimeItemCollection.prototype, "remove", null);
    tslib_1.__decorate([
        action.bound
    ], TimeItemCollection.prototype, "removeAllOn", null);
    return TimeItemCollection;
}());
export default TimeItemCollection;



//////////////////
// WEBPACK FOOTER
// ./src/models/TimeItemCollection.ts
// module id = 347
// module chunks = 0